import React, { useEffect, useState } from 'react';
import { DatePicker, Toast, Picker, Button, InfiniteScroll, Mask, Input } from 'antd-mobile-v5'
import { withRouter } from 'react-router-dom';
import styles from './settlement.module.scss'
import Pass from '../../static/images/pass.png';
import CenterIcon from '../../static/images/centerIcon.png';
import AllChecked from '../../static/images/allChecked.png';
import Checked from '../../static/images/checked.png';
import NoChecked from '../../static/images/noChecked.png';
import arrow_bottom from '../../static/images/arrow_bottom.png';
import calendar from '../../static/images/calendar.png';
import Settlement_empty from '../../static/images/settlement_empty.png';
import Record_empty from '../../static/images/record_empty.png';
import FilterIcon from '../../static/images/filterIcon.png';
import alertCircle from '../../static/images/alertCircle.png';
import settleIcon from '../../static/images/settleIcon.png';
import closeicon from '../../static/images/closeicon.png';
import { ApiCore } from '../../api/index';
import moment from 'moment';
import dateUtils from '../../utils/date';
const api = new ApiCore();
const now = new Date()

let defaultEndDate = moment().format('YYYY/MM/DD')
let defaultStartDate = moment(dateUtils.getBeforeDate(3)).format('YYYY/MM/DD')


const Settlement = (props: any) => {

    const [activeKey, setActiveKey] = useState('1')
    const [recordList, setRecordList] = useState<any>([])
    const [hasMore, setHasMore] = useState(true)
    const [page, setPage] = useState<number>(1)

    const [startDateVisible, setStartDateVisible] = useState(false)
    const [startDate, setStartDate] = useState(defaultStartDate)
    const [endDateVisible, setEndDateVisible] = useState(false)
    const [endDate, setEndDate] = useState(defaultEndDate)
    const [projectVisible, setProjectVisible] = useState(false)
    const [projectList, setProjectList] = useState<any>([])
    const [currentProject, setCurrentProject] = useState<any>({ label: '全部项目', value: '' })
    const [currentProjectCode, setCurrentProjectCode] = useState<any>([])

    const [subjectList, setSubjectList] = useState<any>([])
    const [selectSubject, setSelectSubject] = useState<any>([])

    const [filterVisible, setFilterVisible] = useState(false)
    const [subjectNumber, setSubjectNumber] = useState<any>('')

    const [firstLoad, setFirstLoad] = useState(true)
    const [firstRecordLoad, setFirstRecordLoad] = useState(true)
    const [firstAddLoad, setFirstAddLoad] = useState(true)

    const [balanceCount, setBalanceCount] = useState(0)
    //受试者名称
    const targetName = sessionStorage.getItem('targetName') || '受试者';
    useEffect(() => {
        document.title = '结算申请'
        getProjects()
        // getApproveRecord()
    }, [])


    useEffect(() => {
        if (currentProjectCode.length > 0) {
            setTimeout(() => {
                getSubjectList()
            }, 200);
        }
    }, [currentProjectCode, startDate, endDate])

    useEffect(() => {
        if (currentProjectCode.length > 0) {
            setTimeout(() => {
                getSettlementBalance()
            }, 200);
        }
    }, [currentProjectCode])


    //tab切换
    const changeTab = (avtiveKey: any) => {
        setActiveKey(avtiveKey)

        if (activeKey == '2') {
            setSelectSubject([])
            setStartDate(defaultStartDate)
            setEndDate(defaultEndDate)
            setFirstRecordLoad(true)
        } else {
            getProjects()
            setHasMore(true)
            setRecordList([])
            setPage(1)
        }
    }


    //获取申请记录列表
    const getApproveRecord = async () => {
        let params = {
            page: page,
            pageSize: 10
        }

        let res: any = await api.getSettlementApproveRecord(params)
        if (res.code == 0) {
            setPage(page + 1)
            setRecordList((val: any) => [...val, ...res.data.rows])
            setHasMore(res.data.rows.length === 10)
            setFirstRecordLoad(false)
        } else {
            Toast.show({
                content: res.message
            })
        }
    }

    //获取项目列表
    const getProjects = () => {
        api.getSettlementProjects().then((res: any) => {
            if (res.code == 0) {
                if (res.data && res.data.length > 0) {
                    let list: any = res.data.map((v: any) => ({
                        label: v.projectName,
                        value: v.projectCode
                    }))
                    setProjectList([list])
                    if (!firstLoad) {
                        setCurrentProject(list[0])
                        setCurrentProjectCode([list[0].value])
                    }
                }
                setFirstLoad(false)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    //获取最大结算量
    const getSettlementBalance = () => {
        let params = {
            projectCode: currentProjectCode[0]
        }
        api.getSettlementBalance(params).then((res: any) => {
            if (res.code == 0) {
                setBalanceCount(res.data)
            }
        })
    }

    //获取中心受试者列表
    const getSubjectList = () => {
        let params = {
            startDate: moment(startDate).format('YYYY-MM-DD'),
            endDate: moment(endDate).format('YYYY-MM-DD'),
            projectCode: currentProjectCode[0]
        }
        api.getSettlementSubjectList(params).then((res: any) => {
            if (res.code == 0) {
                if (res.data) {
                    setSubjectList(res.data)
                } else {
                    setSubjectList([])
                }
                setSelectSubject([])
                setFirstAddLoad(false)
            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    //改变当前项目
    const changeProject = (data: any) => {
        setCurrentProjectCode(data)
        let Index = projectList[0].findIndex((v: any) => v.value == data[0])
        if (Index > -1) {
            setCurrentProject(projectList[0][Index])
        }
    }
    //改变开始日期
    const changeStartDate = (value: any) => {
        let date: any = moment(value).format('YYYY/MM/DD');
        setStartDate(date)
    }
    //改变结束日期
    const changeEndDate = (value: any) => {
        let date: any = moment(value).format('YYYY/MM/DD');
        setEndDate(date)
    }

    //中心受试者CheckBox点击
    const clickSubject = (data: any) => {
        let _selectSubject = JSON.parse(JSON.stringify(selectSubject))
        let Index = selectSubject.findIndex((v: any) => v.subjectCode == data.subjectCode)
        let Index2 = subjectList.findIndex((v: any) => v.subjectCode == data.subjectCode)
        if (Index == -1) {
            _selectSubject.push(subjectList[Index2])
        } else {
            _selectSubject.splice(Index, 1)
        }
        setSelectSubject(_selectSubject)
    }

    //全选checkb点击
    const handleAllCheck = () => {
        if (selectSubject.length === subjectList.length) {
            setSelectSubject([])
        } else {
            setSelectSubject(subjectList)
        }
    }

    //提交申请
    const handleApprove = () => {
        let subjectCodeList = selectSubject.map((v: any) => v.subjectCode)
        if (subjectCodeList.length > balanceCount) {
            Toast.show({
                content: `当前选择数量大于可申请结算数量，当前剩余可结算数量为${balanceCount}`
            })
            return false
        }
        let params = {
            projectCode: currentProjectCode[0],
            subjectCodeList
        }
        api.approveSettlement(params).then((res: any) => {
            if (res.code == 0) {
                setSelectSubject([])
                changeTab('1')

            } else {
                Toast.show({
                    content: res.message
                })
            }
        })
    }


    const jumpDetail = (data: any) => {
        props.history.push(`/doctor/settlementDetail/${data.approveRecordId}`);
    }


    const closeMask = () => {
        setFilterVisible(false)
        setSubjectNumber('')
    }

    const handleFill = () => {
        if (!subjectNumber) {
            Toast.show({
                content: '请输入结算数量',
                duration: 2000
            })
            return false;
        }

        if (subjectNumber >= balanceCount) {
            let list = subjectList.slice(0, balanceCount)
            setSelectSubject(list)
        } else {
            let list = subjectList.slice(0, subjectNumber)
            setSelectSubject(list)
        }
        setSubjectNumber('')
        setFilterVisible(false)
    }

    return (
        <>
            {
                !firstLoad && projectList.length == 0 ?
                    <div className={styles.settlement_empty} >
                        <img src={Settlement_empty} alt="" />
                        <div>当前没有项目支持结算申请</div>
                    </div> :
                    <div className={styles.settlement_container} >
                        <div className={styles.tabs_header}>
                            <div className={activeKey == '1' ? `${styles.item_tab} ${styles.active_tab}` : styles.item_tab} onClick={() => changeTab('1')}>申请记录</div>
                            <div className={activeKey == '2' ? `${styles.item_tab} ${styles.active_tab}` : styles.item_tab} onClick={() => changeTab('2')}>新建申请</div>
                        </div>

                        <div className={styles.record_content} hidden={activeKey === '2'}>
                            {
                                !firstRecordLoad && recordList.length == 0 ? <div className={styles.record_empty}>
                                    <img src={Record_empty} alt="" />
                                    <div>当前暂无申请记录</div>
                                </div> :
                                    <div>
                                        {
                                            recordList.map((item: any, index: number) => (
                                                <div className={styles.record} key={index} onClick={() => jumpDetail(item)}>
                                                    <div className={styles.record_head}>
                                                        <div className={item.state == '0' ? styles.record_id : styles.pass_record_id}>{item.name}</div>
                                                        <div className={item.state == '0' ? styles.status : styles.passStatus}>{item.state == '0' ? '审批中' : '审批完成'}</div>
                                                    </div>
                                                    <div className={styles.statistics}>
                                                        <div className={styles.info}>
                                                            <div className={styles.label}>申请数量</div>
                                                            <div>{item.total}例</div>
                                                        </div>
                                                        <div className={styles.info}>
                                                            <div className={styles.label}>已审批通过</div>
                                                            <div>{item.passNum}例</div>
                                                        </div>
                                                        <div className={styles.info}>
                                                            <div className={styles.label}>未已审批通过</div>
                                                            <div>{item.rejectNum}例</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                        <InfiniteScroll loadMore={getApproveRecord} hasMore={hasMore} />
                                    </div>
                            }

                        </div>

                        <div className={styles.addRecord} hidden={activeKey === '1'}>
                            <div className={styles.searchContent}>
                                <div className={styles.project} onClick={() => setProjectVisible(true)}>
                                    <div className={styles.pName}>{currentProject.label}</div>
                                    <Picker
                                        columns={projectList}
                                        visible={projectVisible}
                                        onClose={() => {
                                            setProjectVisible(false)
                                        }}
                                        value={currentProjectCode}
                                        onConfirm={changeProject}
                                    />
                                    <img src={arrow_bottom} alt="" />
                                </div>
                                <div className={styles.date}>
                                    <div className={styles.dateString}>
                                        <span onClick={() => setStartDateVisible(true)}>{startDate}</span>
                                        <DatePicker
                                            title='时间选择'
                                            visible={startDateVisible}
                                            onClose={() => {
                                                setStartDateVisible(false)
                                            }}
                                            max={now}
                                            onConfirm={changeStartDate}
                                        />
                                        <span> - </span>
                                        <span onClick={() => setEndDateVisible(true)}>{endDate}</span>
                                        <DatePicker
                                            title='时间选择'
                                            visible={endDateVisible}
                                            onClose={() => {
                                                setEndDateVisible(false)
                                            }}
                                            max={now}
                                            onConfirm={changeEndDate}
                                        />
                                    </div>
                                    <img src={calendar} alt="" />
                                </div>
                            </div>

                            {
                                !firstAddLoad && subjectList.length == 0 ?
                                    <div className={styles.record_empty}>
                                        <img src={Record_empty} alt="" />
                                        <div>当前暂无可申请的{targetName}</div>
                                    </div> :
                                    <div>
                                        <div className={styles.tip}>已选中 <span>{selectSubject.length}</span> 例数据</div>
                                        <div className={styles.centerList}>
                                            {
                                                subjectList.map((item: any, index: number) => (
                                                    <div className={styles.centerItem} key={index} onClick={() => clickSubject(item)}>
                                                        {(selectSubject.findIndex((v: any) => v.subjectCode == item.subjectCode)) === -1 ?
                                                            <img className={styles.icon_check} src={NoChecked} alt="" /> :
                                                            <img className={styles.icon_check} src={AllChecked} alt="" />
                                                        }

                                                        <div className={styles.center_right}>
                                                            <img className={styles.center_icon} src={CenterIcon} alt="" />
                                                            <div className={styles.center_info}>
                                                                <div className={styles.center_code}>{item.subjectCode}</div>
                                                                <div className={styles.center_name}>{item.centerName}</div>
                                                            </div>
                                                            <img className={styles.center_pass} src={Pass} alt="" />
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <div className={styles.check_footer}>
                                            <div className={styles.footer_left}>
                                                <div className={styles.quickSelect} onClick={() => setFilterVisible(true)}>
                                                    <img className={styles.icon_check} src={FilterIcon} alt="" />
                                                    <span>快速选择</span>
                                                </div>
                                                <div className={styles.allCheck} onClick={handleAllCheck}>
                                                    <img className={styles.icon_check} src={selectSubject.length === 0 ? NoChecked : (selectSubject.length === subjectList.length) ? AllChecked : Checked} alt="" />
                                                    <span>全选</span>
                                                </div>
                                            </div>
                                            <Button color='primary' onClick={handleApprove} className={styles.btn} disabled={selectSubject.length === 0}>
                                                立即申请
                                            </Button>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
            }

            <Mask visible={filterVisible} >
                <div className={styles.filterMask}>
                    <div className={styles.content}>
                        <div className={styles.head}>
                            <div className={styles.left}>
                                <img className={styles.icon_check} src={settleIcon} alt="" />
                                <span>请输入需要结算的数量</span>
                            </div>
                            <img className={styles.close} src={closeicon} alt="" onClick={closeMask} />
                        </div>
                        <div className={styles.input_number}>
                            <Input
                                placeholder='请输入数量'
                                style={{ '--font-size': '14px' }}
                                type='number'
                                value={subjectNumber}
                                max={184}
                                onChange={val => {
                                    setSubjectNumber(val)
                                }}
                            />
                            <span>例</span>
                        </div>
                        <div className={styles.tips}>
                            <div className={styles.tipItem}>
                                <img src={alertCircle} alt="" />
                                当前可申请数量{balanceCount}例
                            </div>
                            <div className={styles.tipItem}>
                                <img src={alertCircle} alt="" />
                                单次最大结算数量184例
                            </div>
                        </div>
                        <div className={styles.submitbtn}>
                            <Button color='primary' onClick={handleFill} className={styles.btn}>
                                确认
                            </Button>
                        </div>
                    </div>
                </div>

            </Mask>
        </>
    )
}


export default withRouter(Settlement);